module.exports = __webpack_public_path__ + "h5/img/datitop.74fc8765.png";